// extracted by mini-css-extract-plugin
module.exports = {"container":"Loading_container__1aMyo","animation":"Loading_animation__1iGhr","text":"Loading_text__2sRFN"};